// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__1uct_","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2j0dO"};